import React, { ComponentType, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import LoadingSpinner from 'components/ui/LoadingSpinner';
import ErrorBoundaryFallback from 'App/ErrorBoundaryFallback';
import { logError } from 'utils/errorHandling';

const withLazyLoading = <T extends ComponentType<any>>(
    importFunc: () => Promise<{ default: T }>,
    displayName: string,
): ComponentType<any> => {
    const lazyName = `LazyLoaded(${displayName})`;
    const LazyComponent = React.lazy(importFunc);

    const LazyLoadedComponent: ComponentType<any> = (props) => (
        <ErrorBoundary
            fallbackRender={ErrorBoundaryFallback}
            onError={(error, info) => logError(`Component ${lazyName} failed to render`, error, info)}
        >
            <Suspense fallback={<LoadingSpinner />}>
                <LazyComponent {...props} />
            </Suspense>
        </ErrorBoundary>
    );

    LazyLoadedComponent.displayName = lazyName;

    return LazyLoadedComponent;
};

export default withLazyLoading;
